if (!customElements.get("announcement-slider")) {
  class AnnouncementSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = new Swiper(this.querySelector(".swiper"), {
        loop: true,
        slidesPerView: 1,
        autoplay: {
          delay: this.dataset.delay ?? 5000,
          pauseOnMouseEnter: true,
        },
      });
    }
  }
  customElements.define("announcement-slider", AnnouncementSlider);
}
